// File: subscription.js
import api from './axios';

const endpoints = {
  subscription: '/api/v1/subscription',
};

export const createStripeSubscription = async ({
  paymentMethodId,
  planId,
  planPrice,
  billingInterval,
  email,
}) => {
  try {
    const response = await api.post(endpoints.subscription, {
      paymentMethodId,
      planId,
      planPrice,
      billingInterval,
      email,
    });
    return response;
  } catch (error) {
    throw new Error(error.message || 'Failed to create Stripe subscription');
  }
};
